export default __webpack_public_path__ + "static/media/docs1.8b932aca.png";